import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SchedulingAssistantState = {
  schedulingAssistant: {
    docketEntryTypeId: undefined,
    endDate: undefined,
    errors: [],
    events: [],
    startDate: undefined,
    runningRequests: 0,
    timezone: 'local',
  },
}

export const SchedulingAssistantActions = {
  clearSchedulingAssistantEvents ({ commit }) {
    commit('setSchedulingAssistantEvents', [])
  },

  async fetchSchedulingAssistantEvents ({ commit, state }) {
    commit('addSchedulingAssistantRunningRequest')
    commit('setSchedulingAssistantEvents', [])

    return axiosRequest.get(
      '/calendar/events',
      {
        params: {
          end_date: state.schedulingAssistant.endDate,
          start_date: state.schedulingAssistant.startDate,
          user_ids: state.schedulingAssistant.users,
        },
      }
    ).
      then(({ data }) => {
        commit('setSchedulingAssistantEvents', data)
      }).
      catch(handleError).
      finally(_ => { commit('removeSchedulingAssistantRunningRequest') })
  },

  setSchedulingAssistantDates ({ commit }, { endDate, startDate }) {
    commit('setSchedulingAssistantEvents', [])
    commit('updateSchedulingAssistantDates', { endDate, startDate })
  },

  setSchedulingAssistantDocketEntryType ({ commit }, docketEntryTypeId) {
    commit('setSchedulingAssistantEvents', [])
    commit('updateSchedulingAssistantDocketEntryType', docketEntryTypeId)
  },

  setSchedulingAssistantTimezone ({ commit }, timezone) {
    commit('setSchedulingAssistantEvents', [])
    commit('updateSchedulingAssistantTimezone', timezone)
  },
}

export const SchedulingAssistantMutations = {
  addSchedulingAssistantRunningRequest: state => state.schedulingAssistant.runningRequests++,

  removeSchedulingAssistantRunningRequest: state => state.schedulingAssistant.runningRequests--,

  updateSchedulingAssistantDates: (state, { endDate, startDate }) => {
    state.schedulingAssistant.endDate = endDate
    state.schedulingAssistant.startDate = startDate
  },

  updateSchedulingAssistantDocketEntryType: (state, docketEntryTypeId) => {
    state.schedulingAssistant.docketEntryTypeId = docketEntryTypeId
  },

  updateSchedulingAssistantEvents: (state, events) => {
    state.schedulingAssistant.events = events
  },

  updateSchedulingAssistantTimezone: (state, timezone) => {
    state.schedulingAssistant.timezone = timezone
  },
}

export const SchedulingAssistantGetters = {
  schedulingAssistantDocketEntryTypeId: state => state.schedulingAssistant.docketEntryTypeId,
  schedulingAssistantEndDate: state => state.schedulingAssistant.endDate,
  schedulingAssistantIsLoading: state => state.schedulingAssistant.runningRequests !== 0,
  schedulingAssistantEvents: state => state.schedulingAssistant.events,
  schedulingAssistantStartDate: state => state.schedulingAssistant.startDate,
  schedulingAssistantTimezone: state => state.schedulingAssistant.timezone,
}
